import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/nhl-legacy-team-stacking/actions';

class TeamPPLines extends Component {
    onChange(ppLine, isChecked) {
        this.props.dispatch(Action.setTeamPPLinesForStackNumber(
            {[ppLine]: isChecked},
            this.props.team,
            this.props.stackNumber,
        ));
    }
    render() {
        const {team, stackNumber, stacking} = this.props;
        const ppLines = stacking.getTeamPPLines(stackNumber, team);

        return (
            <div className="chk-group-container">
                <strong className="chk-group-title">PP Lines:</strong>
                <div className="chk-group">
                    {Object.keys(ppLines).map(ppLine => (
                        <label key={ppLine}>
                            <input
                                type="checkbox"
                                checked={ppLines[ppLine]}
                                onChange={e => ::this.onChange(ppLine, e.target.checked)}/>
                            <span>{ppLine}</span>
                        </label>
                    ))}
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        nhlLegacyTeamStacking,
    } = state;

    return {
        stacking: nhlLegacyTeamStacking,
    }
}

export default connect(mapStatesToProps)(TeamPPLines);
